import React from 'react';
import styles from './RoomDdy.module.scss';
import { Spin } from 'antd';
import InfoCard from '../../common/InfoCard/InfoCard';
import useFlatsGridState from '../../../hooks/useFlatsGridState';
import { useSelector } from 'react-redux';
import moment from 'moment';
import TitleCard from '../RoomStage/TitleCard';

const RoomDdy = ({ className, title, darkTheme = true, openForm }) => {
  const { flatsGridState, flatsGridQueryKey } = useFlatsGridState();

  const currentFlat = useSelector(
    (state) => state.housingStockStore.currentFlat
  );

  const changeAddressAttribute = useSelector(
    (state) => state.authentication.userInfo.ChangeAddressAttribute
  );

  return (
    <Spin spinning={flatsGridState?.status === 'loading' || !flatsGridQueryKey}>
      <InfoCard
        title={
          <TitleCard
            title={title}
            openForm={changeAddressAttribute ? openForm : undefined}
            icon="edit"
          />
        }
        className={className}
        dark={darkTheme}
      >
        <ul className={styles.metersList}>
          <li>
            <InfoCard
              title="Номер помещения по ДДУ"
              className={styles.wrapperLife}
            >
              <p className={styles.content}>
                {currentFlat?.address?.addressDdu || 'Нет данных'}
              </p>
            </InfoCard>
          </li>
          <li>
            <InfoCard title="Номер ДДУ" className={styles.wrapperLife}>
              <p className={styles.content}>
                {currentFlat?.address?.numberDdu || 'Нет данных'}
              </p>
            </InfoCard>
          </li>
          <li>
            <InfoCard title="Дата ДДУ" className={styles.wrapperLife}>
              <p className={styles.content}>
                {!!currentFlat?.address?.dateDdu
                  ? moment(currentFlat?.address?.dateDdu).format('DD.MM.YYYY')
                  : 'Нет данных'}
              </p>
            </InfoCard>
          </li>
          <li>
            <InfoCard
              title="Дата подписания Акта приема-передачи"
              className={styles.wrapperLife}
            >
              <p className={styles.content}>
                {!!currentFlat?.address?.dateSignAct
                  ? moment(currentFlat?.address?.dateSignAct).format(
                      'DD.MM.YYYY'
                    )
                  : 'Нет данных'}
              </p>
            </InfoCard>
          </li>
          <li>
            <InfoCard title="Вид отделки" className={styles.wrapperLife}>
              <p className={styles.content}>
                {currentFlat?.address?.addressTypeFinishName || 'Нет данных'}
              </p>
            </InfoCard>
          </li>
          <li>
            <InfoCard
              title="Форма собственности"
              className={styles.wrapperLife}
            >
              <p className={styles.content}>
                {currentFlat?.address?.formOwnershipName || 'Нет данных'}
              </p>
            </InfoCard>
          </li>
        </ul>
      </InfoCard>
    </Spin>
  );
};

export default RoomDdy;
